const VOLATILE_STATE_KEYS = new Set([
  'timestamp',
  'lastModified',
  'createdAt',
  'updatedAt',
  'lastSaveTime'
]);

export function normalizeBusinessState(input: unknown): unknown {
  return normalizeValue(input);
}

export function buildBusinessStateSignature(input: unknown): string {
  return JSON.stringify(normalizeBusinessState(input));
}

export function hasEquivalentBusinessState(left: unknown, right: unknown): boolean {
  return buildBusinessStateSignature(left) === buildBusinessStateSignature(right);
}

function normalizeValue(value: unknown): unknown {
  if (Array.isArray(value)) {
    return value.map(item => normalizeValue(item));
  }

  if (value && typeof value === 'object') {
    if (value instanceof Date) {
      return value.toISOString();
    }

    const normalized: Record<string, unknown> = {};
    const source = value as Record<string, unknown>;
    const keys = Object.keys(source)
      .filter(key => !VOLATILE_STATE_KEYS.has(key))
      .sort();

    for (const key of keys) {
      normalized[key] = normalizeValue(source[key]);
    }

    return normalized;
  }

  return value;
}